function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#ABABAB"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.55 8.137L5.431 9l-3.894 3.887c-.119.117-.186.277-.187.444 0 .167.068.327.187.444l2.65 2.656c.244.243.638.243.882 0l3.894-3.869.875.888-3.894 3.869c-.352.345-.826.538-1.319.537-.496.001-.973-.194-1.325-.544l-2.644-2.65c-.355-.352-.554-.83-.554-1.33 0-.5.2-.98.554-1.332L4.55 8.137zm7.575 4.613v3.125h-1.25V12.75h1.25zm3.75-1.875v1.25H12.75v-1.25h3.125zM12.05.644c.731-.727 1.912-.727 2.644 0l2.65 2.656c.351.351.55.828.55 1.325.004.501-.197.982-.556 1.331L13.443 9.82l-.882-.888 3.9-3.862c.119-.118.185-.277.185-.444 0-.167-.066-.326-.184-.444l-2.65-2.65c-.118-.118-.278-.185-.444-.185-.167 0-.327.067-.444.185L9.031 5.394l-.881-.888zm-6.8 5.231v1.25H2.125v-1.25H5.25zm1.875-3.75V5.25h-1.25V2.125h1.25z",
  transform: "translate(-298 -533) translate(298 533)"
}))));

var SvgLinkBroken = function SvgLinkBroken(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkBroken, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-broken.ac6ec6b5.svg";
export { ForwardRef as ReactComponent };